module.exports = __webpack_public_path__ + "img/910.25d2b069.png";